<template>
  <el-dialog
    class="dialog-style-public"
    :close-on-click-modal="false"
    :title="$t('canvas.BTCDialog.dialogTitle')"
    :visible="visible"
    width="602px"
    top="10vh"
    @close="closeDialog"
    append-to-body
  >
    <div class="changeHashText">
      {{ $t("canvas.BTCDialog.description") }}
      <span style="color: rgba(5, 171, 250, 1)"> {{ total }}</span>
      {{ $t("canvas.BTCDialog.descriptionSuffix") }}
    </div>
    <div class="tableStyle" style="margin-bottom: 20px">
      <el-table :data="BTCtableData" style="width: 100%">
        <el-table-column
          prop="hash"
          :label="$t('canvas.BTCDialog.table.columns.transactionHash')"
          width="180"
        >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.hash" placement="top">
              <span>
                <span class="textStyle">
                  {{
                    scope.row.hash ? scope.row.hash.substr(0, 14) + "..." : "--"
                  }}
                </span>
                <svg
                  style="margin-left: 3px; cursor: pointer"
                  @click="copyBtn(scope.row.hash)"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.25 1C2.85217 1 2.47064 1.15804 2.18934 1.43934C1.90804 1.72064 1.75 2.10217 1.75 2.5V8.5C1.75 8.8978 1.90804 9.27935 2.18934 9.56065C2.47064 9.84195 2.85217 10 3.25 10H3.75V10.5C3.75 11.3285 4.42158 12 5.25 12H9.25C10.0785 12 10.75 11.3285 10.75 10.5V4.5C10.75 3.67158 10.0785 3 9.25 3H8.75V2.5C8.75 2.10217 8.59195 1.72064 8.31065 1.43934C8.02935 1.15804 7.6478 1 7.25 1H3.25ZM7.75 3V2.5C7.75 2.36739 7.6973 2.24022 7.60355 2.14645C7.5098 2.05268 7.3826 2 7.25 2H3.25C3.11739 2 2.99022 2.05268 2.89645 2.14645C2.80268 2.24022 2.75 2.36739 2.75 2.5V8.5C2.75 8.6326 2.80268 8.7598 2.89645 8.85355C2.99022 8.9473 3.11739 9 3.25 9H3.75V4.5C3.75 3.67158 4.42158 3 5.25 3H7.75ZM4.75 10.5C4.75 10.7761 4.97386 11 5.25 11H9.25C9.52615 11 9.75 10.7761 9.75 10.5V4.5C9.75 4.22386 9.52615 4 9.25 4H5.25C4.97386 4 4.75 4.22386 4.75 4.5V10.5Z"
                    fill="#87909F"
                  />
                </svg>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          :label="$t('canvas.BTCDialog.table.columns.transactionAmount')"
          width="130"
        >
          <template slot-scope="scope">
            <!-- {{ "+" + Number(scope.row.quantity).toLocaleString() }} -->
            <span
              class="INFLOWcellName"
              v-if="scope.row.direction == 'INFLOW'"
              >{{ "+" + scope.row.quantity }}</span
            >
            <span
              class="OUTFLOWcellName"
              v-if="scope.row.direction == 'OUTFLOW'"
              >{{ "-" + scope.row.quantity }}</span
            >
            <span v-if="scope.row.quantity == 0">{{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="txTime"
          :label="$t('canvas.BTCDialog.table.columns.transactionTime')"
          :show-overflow-tooltip="true"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.txTime || "--" }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('canvas.BTCDialog.table.columns.actions')">
          <template slot-scope="scope">
            <div class="addHashStyle" @click="joinCanvas(scope.row)">
              <CanvasIcons name="addHash" />
              <span class="textStyle" style="margin-left: 4px">{{
                $t("canvas.BTCDialog.table.actions.joinCanvas")
              }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <div class="bottomblock">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageRequest.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageRequest.size"
            layout="prev, pager, next,sizes"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import CanvasIcons from "@/components/icons/CanvasIcons.vue";
import { commway } from "@/utils/commway";
import dayjs from "dayjs";
import { pageBitcoinAddressTransaction } from "@/aips/canvas/singlecurrency";
import { getAddCanvas } from "@/aips/canvas";
export default {
  name: "BTCDialog",
  mixins: [commway],
  components: {
    CanvasIcons,
  },
  data() {
    return {
      BTCtableData: [],
      total: 0,
      pageRequest: {
        page: 1,
        size: 10,
      },
    };
  },
  props: ["visible", "BTCresdata", "temporarilSingleyCanvas"],
  watch: {
    BTCresdata: {
      handler(newVal) {
        console.log("我是接收到的数据");
        console.log(newVal);
        if (newVal) {
          this.BTCtableData = newVal.data.content;
          this.total = newVal.data.totalElements;
          this.pageRequest.address = newVal.address;
          this.pageRequest.blockchain = newVal.blockchain;
        }
      },
      immediate: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit("close");
    },
    //加入画布
    joinCanvas(row) {
      console.log(row);
      if (this.temporarilSingleyCanvas) {
        this.$emit("addcanvasfn", row);
      } else {
        let params = { ...this.BTCresdata.params };
        params.rootNode = row.hash;
        getAddCanvas(params).then((res) => {
          console.log("我是新建画布");
          console.log(res);
          if (res.code == 200) {
            res.data.address = row.hash;
            res.data.singleCurrency = this.BTCresdata.singleCurrency;
            console.log(res.data);
            this.$emit("addcanvasfn", res.data);
          }
        });
      }
    },
    handleSizeChange(val) {
      this.pageRequest.size = val;
      this.pageRequest.page = 1;
      this.getbtcList();
    },

    handleCurrentChange(val) {
      this.pageRequest.page = val;
      this.getbtcList();
    },
    getbtcList() {
      pageBitcoinAddressTransaction(this.pageRequest).then((res) => {
        res.data.content.forEach((item) => {
          if (item.txTime) {
            item.txTime = dayjs.unix(item.txTime).format("YYYY-MM-DD HH:mm");
          }
        });
        this.BTCtableData = res.data.content;
        this.total = res.data.totalElements;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.changeHashText {
  width: 552px;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 4px;
  background: rgba(5, 171, 250, 0.1);
  color: var(--web-color-text-secondary, rgba(135, 144, 159, 1));
  font-family: "San Francisco Text";
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 19px;
}
.addHashStyle {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.textStyle {
  color: rgba(5, 171, 250, 1);
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.INFLOWcellName {
  color: #0aa869;
}
.OUTFLOWcellName {
  color: #fe445c;
}
.tablebottom {
  margin-top: 24px;
}
::v-deep .el-pagination__sizes {
  // margin: 0 -10px 0 0 !important;
}
</style>
